import { useState, useEffect } from 'react';

import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import * as gatewayService from '@frolight/services/api/gatewayService';

const useRegisterGatewaysToOrganisation = ( unregisteredGateways, organisationId, allowExecution ) => {

  const [ loading, setLoading ] = useState(false);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();

  useEffect(() => {
    let mounted = true;

    const abortControllers = [];

    const runEffect = async () => {
      if (mounted) setLoading(true);
      try {
        const responses = await Promise.all(unregisteredGateways.map(async (gateway) => {
          const abortController = new AbortController();
          abortControllers.push(abortController);

          const response = await authenticatedAPIServiceCall(
            gatewayService.registerGatewayToOrganisation,
            {
              abortController: abortController,
              opts: {
                gatewayId: gateway.id,
                organisationId: organisationId
              }
            }
          );

          return response;
        }));
        if (mounted) setData(responses);
      } catch (err) {
        if (mounted) {
          if (err.name !== 'AbortError') {
            setError(err);
          }
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (unregisteredGateways && organisationId && allowExecution) {
      runEffect();
    }

    return () => {
      mounted = false;
      abortControllers.forEach(abortController => abortController.abort());
    }
  }, [ organisationId, unregisteredGateways, allowExecution ]);

  return { loading, error, data };
};

export default useRegisterGatewaysToOrganisation;